import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, ColumnSeries, Category, DataLabel, Tooltip, Legend } from '@syncfusion/ej2-react-charts';
import { FacilityCenterBreakdownView } from '../../../../services/ReportingService';

interface CostOverviewChartProps {
  centerData: FacilityCenterBreakdownView[];
}

const CostOverviewChart: React.FC<CostOverviewChartProps> = ({ centerData }) => {
  const costOverviewData = centerData.map((center) => ({
    centerName: center.centerName,
    estimatedCost: center.estimatedCost,
  }));

  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          Cost Overview
        </Typography>
        {costOverviewData.length > 0 ? (
          <ChartComponent
            id="cost-overview"
            primaryXAxis={{ valueType: 'Category' }}
            primaryYAxis={{ title: 'Cost ($)' }}
            tooltip={{ enable: true }}
            height="300px"
          >
            <Inject services={[ColumnSeries, Category, DataLabel, Tooltip, Legend]} />
            <SeriesCollectionDirective>
              <SeriesDirective
                dataSource={costOverviewData}
                xName="centerName"
                yName="estimatedCost"
                type="Column"
                name="Estimated"
                fill="#10b981"
              />
            </SeriesCollectionDirective>
          </ChartComponent>
        ) : (
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" color="#64748b">
              No data available
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default CostOverviewChart;
